export enum AvatarSize {
  XS = 25,
  S = 30,
  M = 50,
  L = 80,
  XL = 160,
}
